/**
 * @name AuthLayout
 * @description Layout para páginas de autenticação
 * @author Gabriel M. Guimarães | gabrielmg7
 */

import GradientBackground from '@/components/common/backgrounds/GradientBackground';
import { Box, Container } from '@mui/material';
import React from 'react';
import { Outlet } from 'react-router-dom';

export const AuthLayout: React.FC = () => {
     return (
          <GradientBackground>
               <Box
                    sx={{
                         minHeight: '100vh',
                         display: 'flex',
                         alignItems: 'center',
                         justifyContent: 'center',
                         p: 2,
                    }}
               >
                    <Container maxWidth='sm'>
                        
                              <Outlet />
                    </Container>
               </Box>
          </GradientBackground>
     );
};
